import { keyframes, styled } from '@/stitches.config';

const spin = keyframes({
  '0%': { transform: 'rotate(0)' },
  '100%': { transform: 'rotate(1turn)' },
});

const LoadingWrapper = styled('div', {
  position: 'absolute',
  left: 0,
  width: '100%',
  height: '100%',
  top: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  pe: 'none',
});

const LoadingInner = styled('div', {
  position: 'relative',
  width: '30px',
  height: '30px',
});

const LoadingCircle = styled('div', {
  position: 'absolute',
  left: 0,
  width: '100%',
  height: '100%',
  top: 0,
  animationName: `${spin}`,
  animationDuration: '.8s',
  animationTimingFunction: 'linear',
  animationIterationCount: 'infinite',
});

const LoadingBack = styled('div', {
  position: 'absolute',
  left: 0,
  width: '100%',
  height: '100%',
  top: 0,
  br: '50%',
  mixBlendMode: 'exclusion',
  border: '2px solid $white',
  borderRight: '2px solid hsla(0,0%,100%,.2)',
  borderLeft: '2px solid hsla(0,0%,100%,.2)',
});

const LoadingFront = styled('div', {
  position: 'absolute',
  left: 0,
  width: '100%',
  height: '100%',
  top: 0,
  br: '50%',
  mixBlendMode: 'exclusion',
  border: '2px solid hsla(0,0%,100%,.3)',
});

type IProps = React.ComponentProps<typeof LoadingWrapper>;

export const LoadingSpinner: React.FunctionComponent<IProps> = (
  props: IProps
) => (
  <LoadingWrapper css={props.css}>
    <LoadingInner>
      <LoadingCircle>
        <LoadingBack />
        <LoadingFront />
      </LoadingCircle>
    </LoadingInner>
  </LoadingWrapper>
);

LoadingSpinner.displayName = 'SharedElementLoadingSpinner';
